import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
// import AddPalletesationTables from "../tables/AddPalletesationTable";
import { useFormik, FormikProvider } from "formik";
// import * as Yup from "yup";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import AWS from 'aws-sdk';
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import $ from "jquery";
const RawMaterialPricingEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  // const [valueContents, setValueContents] = useState([]);
  const [permission, setPermission] = useState({});

  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  // const [farmerLists, setFarmerLists] = useState([]);
  const [primaryCurrency, SetPrimaryCurrency] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState('dh');

   const [productname, setProductname] = useState('');


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const formik = useFormik({
    initialValues: {
      id: value.id,
      currency: value.currency,
      grade_a_price: value.grade_a_price,
      grade_b_price: value.grade_b_price,
      grade_a_plus_price: value.grade_a_plus_price
    },
    enableReinitialize: true,
    //validationSchema: EditUserSchema,
    onSubmit: (values, { setSubmitting }) => {
      axios
        .post("/raw-materials/update-pricing", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("Update Raw Materials Pricing");
          delete backendErrors['error'];
          // actions.setSubmitting(false);
          setSubmitting(false);
          if (response.data.code === 200) {
            //  setBackendSuccess(response.data.message);
            toast.success(response.data.message);
            //   actions.resetForm();
            setTimeout(() => {
              window.location.href = "/raw-material-pricing";
            }, 1000);
          } else if (response.data.code === 422) {
            setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
            setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  useEffect(() => {
    setPermission(FindModuleById(191));
    console.log(permission);
    axios
      .get(`/helpers/currencies`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let currencies = response.data.data.currencies;
          let supplierslist = currencies.map((cat, index) => ({
            label: cat.title,
            value: cat.id,
            symbol: cat.symbol,
            key: `cabrane-${index}`,
          }));
          SetPrimaryCurrency(supplierslist);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`/raw-materials/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {

          setValue(response.data.data.raw);
          let materials = response.data.data.raw.palletesation;

         const productnames = materials.map(item => item.productname);
         const uniqueString = [...new Set(productnames)].join('| ');
        setProductname(uniqueString);

          axios.get(`/helper/currency-symbol-by-currency-id/${response.data.data.raw.currency}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
            .then((response) => {
              if (response.data.code === 200) {
                // console.log(response.data.data);
                setCurrencySymbol(response.data.data.currency_symbol)

              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      })
      .catch((error) => {
        console.log(error);
      });




  }, [id]);

  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  const customFuction = (event) => {
    console.log(event);
    setCurrencySymbol(event.symbol);

  }
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };

  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Raw Material Pricing</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/raw-material-pricing">Raw Material Pricing</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              {permission && permission.update === 1 && (
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <div className="customer-details m-3">
                            <div className="d-flex align-items-center">
                              <div className="customer-details-cont">
                                <h6>Lot Number </h6>
                                <p>{value.lot_number}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <div className="customer-details m-3">
                            <div className="d-flex align-items-center">
                              <div className="customer-details-cont">
                                <h6>Date & time</h6>
                                <p>{value.date_time}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <div className="customer-details m-3">
                            <div className="d-flex align-items-center">
                              <div className="customer-details-cont">
                                <h6>Shift Date</h6>
                                <p>{value.shift_date}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <div className="customer-details  m-3">
                            <div className="d-flex align-items-center">
                              <div className="customer-details-cont">
                                <h6>Plate Number</h6>
                                <p>{value.plate_number}</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <div className="customer-details  m-3">
                            <div className="d-flex align-items-center">
                              <div className="customer-details-cont">
                                <h6>Farmer Name</h6>
                                <p>{value.farmer_detail ? value.farmer_detail.name : ""}</p>
                              </div>
                            </div>
                          </div>
                        </div>



                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <div className="customer-details  m-3">
                            <div className="d-flex align-items-center">
                              <div className="customer-details-cont">
                                <h6>Location</h6>
                                <p>{value.location_name ? value.location_name.title : ""}</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <div className="customer-details  m-3">
                            <div className="d-flex align-items-center">
                              <div className="customer-details-cont">
                                <h6>Supplier</h6>
                                <p>{value.supplier_name ? value.supplier_name.name : ""}</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <div className="customer-details  m-3">
                            <div className="d-flex align-items-center">
                              <div className="customer-details-cont">
                                <h6>BL Net Weight</h6>
                                <p>{value.net_weight}KG</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <div className="customer-details  m-3">
                            <div className="d-flex align-items-center">
                              <div className="customer-details-cont">
                                <h6>BL Gross Weight</h6>
                                <p>{value.gross_weight}KG</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <div className="customer-details  m-3">
                            <div className="d-flex align-items-center">
                              <div className="customer-details-cont">
                                <h6>Grade A Net Weight</h6>
                                <p>{(value.id > 357) ? value.grade_a_bl_weight : value.grade_a_net_weight}KG</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <div className="customer-details  m-3">
                            <div className="d-flex align-items-center">
                              <div className="customer-details-cont">
                                <h6>Grade B Net Weight</h6>
                                <p>{(value.id > 357) ? value.grade_b_bl_weight : value.grade_b_net_weight}KG</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        </div>
                         <div className="row">
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <div className="customer-details  m-3">
                            <div className="d-flex align-items-center">
                              <div className="customer-details-cont">
                                <h6>Note</h6>
                                <p>{value.note}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <div className="customer-details  m-3">
                            <div className="d-flex align-items-center">
                              <div className="customer-details-cont">
                                <h6>Product</h6>
                                <p>{productname}</p>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {permission && permission.update === 1 && (
              <FormikProvider value={formik}>
                <form onSubmit={formik.handleSubmit}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card">
                        <div className="card-body">
                          <h4 className="card-title">Raw Material Pricing </h4>
                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group status2">
                                <label>Select Currency</label>
                                <Select

                                  className="w-100"
                                  value={primaryCurrency.find(option => option.value == formik.values.currency) || null} // Ensure correct format
                                  name="currency"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("currency", selectedOption);
                                    customFuction(selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={primaryCurrency}
                                  placeholder="Select"

                                />

                                <small>
                                  {backendErrors.currency && (
                                    <span className="form-error mt-1">
                                      {backendErrors.currency}
                                    </span>
                                  )}
                                </small>
                              </div>

                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Grade A Price</label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    onKeyPress={(event) => {
                                      // Allow only numbers (0-9)
                                      if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                        event.preventDefault();
                                      }
                                    }}
                                    name="grade_a_price"
                                    value={formik.values.grade_a_price}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="Price" aria-label="Price" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                    <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                  </div>
                                </div>
                                <small>
                                  {backendErrors.grade_a_price && (
                                    <span className="form-error mt-1">
                                      {backendErrors.grade_a_price}
                                    </span>
                                  )}
                                </small>
                              </div>

                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Grade B Price</label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    onKeyPress={(event) => {
                                      // Allow only numbers (0-9)
                                      if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                        event.preventDefault();
                                      }
                                    }}
                                    name="grade_b_price"
                                    value={formik.values.grade_b_price}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="Price" aria-label="Price" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                    <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                  </div>
                                </div>
                                <small>
                                  {backendErrors.grade_b_price && (
                                    <span className="form-error mt-1">
                                      {backendErrors.grade_b_price}
                                    </span>
                                  )}
                                </small>
                              </div>

                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>





                  <div className="row">
                    <div className="col-md-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="text-end mt-4">
                            <button className="btn btn-primary" type="submit" id="form-submit" disabled={formik.isSubmitting}>
                              Update Raw Materials Pricing
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </form>
              </FormikProvider>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default RawMaterialPricingEdit;
